module.exports = __webpack_public_path__ + "static/media/IoTworld.1cd78b29.jpg";